import React, {useEffect, useState} from "react";


import get from "lodash/get";

import { connect } from "react-redux";
import { bindActionCreators,compose } from "redux";



import {
    loadAccess,
    loadLevel,
    setLoading,
    loadUser,
} from "@app/common/store/action";
import {  withRouter } from "react-router-dom";
import QRCode from "react-qr-code";

import Axios from "axios";
import {getCookie} from "../../../../helper/cookie";

import Grid from "@material-ui/core/Grid";

import style from './mfascanform.module.css'
import MFACodeContainer from "../../../../components/mfacodecontainer/mfacodecontainer";

import MFATextContainer from "./MFATextContainer";

import TwoButtonContainer from "../../../../components/twobuttoncontainer/twobuttoncontainer";
import {
    FETCH_MFA_SCAN_BAR_SUC_200, MFA_CFM_SUC_200, MFA_OTP_WRONG_ERR,
} from "@app/common/constants/constants";
import {fetchMFAScanBarService} from "@app/common/services/fetchscanbarservice";
import { mfaSetupCodeVerifyService} from "@app/common/services/mfasetupcodeverifyservice";
import {getScanName, LOGIN_ROUTE} from "../../../../constants/routeconstants";
import {
    CODE_LENGTH,
    MFA_SETUP_STEP_1, MFA_SETUP_STEP_2, MFA_SETUP_STEP_3, MFA_SETUP_STEP_4,
    MFA_SETUP_STEP_TITLE, MFA_SETUP_SUCCESSFUL_STATUS,
    OTP_EMPTY_ERR, PASSWORD_FAILURE_STATUS, PASSWORD_SUCCESSFUL_STATUS,
    SUBMIT
} from "../../../../constants/appconstants";
import {LOADING_SUCCESS_STATUS} from "../../../../components/loading/constants";
import {env} from "@app/common/config/url-config";


function MFAScanForm(props){
    const [errorText,setErrorText] = useState("");
    const [otpErrorStatus,setOTPErrorStatus] = useState(false);
    const [secretCode,setSecretCode]  = useState(undefined);
    const [code,setCode]  = useState("");
    const [mfaSession,setMFASession]  = useState("");
    useEffect(()=>{
        const status = get(this, "props.location.state.status");

         onLoadScanBar();
    },[])



    const onLoadScanBar = async ()=>{
        const {actions,session} = props;


        try{
            let response = await fetchMFAScanBarService(session);
            let serviceResponseHeader = get(response,"serviceResponseHeader");
            let serviceResponseBody = get(response,"serviceResponseBody");
            let statusCode = get(serviceResponseHeader,"statusCode");
            let mfaSession = get(serviceResponseBody,"session");
            let secretCode = get(serviceResponseBody,"secretCode")
            if (statusCode === FETCH_MFA_SCAN_BAR_SUC_200) {
                Axios.defaults.headers.common['X-CSRF-TOKEN'] =getCookie("iccd");
                setSecretCode(secretCode);
                setMFASession(mfaSession)
            }
        }catch(e){

            console.log(e)
            setErrorText(e)
        }
    }

    const onSubmitHandler = async (e) => {
        e.preventDefault();

        const { actions } = props;
        if(code === "" || code.length < CODE_LENGTH){
            setCode("")
            setOTPErrorStatus(true);
            setErrorText(OTP_EMPTY_ERR)
            return
        }

        actions.setLoading(true);
        try{
            let response = await mfaSetupCodeVerifyService(mfaSession,code);
            let serviceResponseHeader = get(response,"serviceResponseHeader");
            let statusCode = get(serviceResponseHeader,"statusCode");
            actions.setLoading(false,LOADING_SUCCESS_STATUS,MFA_SETUP_SUCCESSFUL_STATUS,"",true);

            if (statusCode === MFA_CFM_SUC_200)
               props.history.push(LOGIN_ROUTE)
        }catch(e){
            actions.setLoading(false);
            if(e === MFA_OTP_WRONG_ERR){
                setOTPErrorStatus(true);
            }
            console.log(e)
            setErrorText(e)
            setCode("")
          //  this.setState({ errorText:e,userName: "",password: "", buttonDisabled:true});
        }
    };

    const onCloseRequestHandler = ()=>{
        console.log("closse")
        props.history.push(LOGIN_ROUTE)
    }
    const setMFACodeHandler = (code)=>{
        console.log("code",code)
       setCode(code)
    }
    console.log("userName",props.user.userName)
    const environment= getScanName();
    const authCode = "otpauth://totp/"+environment + props.user.userName + "?secret=" + secretCode + "&issuer=DSLMonitoring";
    return (
        <form onSubmit={onSubmitHandler}>

            <Grid container direction={"column"} justify={"center"} alignItems={"center"} className={style.mfa_scan_form_container}>
                <Grid item className={style.mfa_scan_form_scan_text_title}>
                    {MFA_SETUP_STEP_TITLE}
                </Grid>

                <Grid item className={style.mfa_scan_form_scan_text}>
                    <MFATextContainer number={1} text={MFA_SETUP_STEP_1}/>
                </Grid>
                <Grid item className={style.mfa_scan_form_scan_text}>
                    <MFATextContainer number={2} text={MFA_SETUP_STEP_2}/>
                </Grid>

                <Grid item className={style.mfa_scan_form_scan_text}>
                    <MFATextContainer number={3} text={MFA_SETUP_STEP_3}/>
                </Grid>
                <Grid item className={style.mfa_scan_form_box}>
                    {secretCode?<QRCode value={authCode} size={100}/>:null}
                </Grid>
                <Grid item className={style.mfa_scan_code_desc_text}>
                    <MFATextContainer number={4} text={MFA_SETUP_STEP_4}/>
                </Grid>
                <Grid item className={style.mfa_scan_form_code_container}>
                    <MFACodeContainer setCodeRequestHandler={setMFACodeHandler} code={code} errorText={errorText} errorStatus={otpErrorStatus}/>
                </Grid>
                <Grid item className={style.mfa_scan_form_code_container}>
                    <TwoButtonContainer title={SUBMIT}
                                        onSubmitRequestHandler={onSubmitHandler}
                                        onCloseRequestHandler={onCloseRequestHandler}/>
                </Grid>
            </Grid>
        </form>

    );
}

const mapStateToProps = (state, ownProps) => ({
    access: state.access,
    session:state.session,
    user:state.user,
});

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(
            { loadAccess, loadLevel, setLoading, loadUser },
            dispatch
        ),
    };
}

export default compose(connect(mapStateToProps, mapDispatchToProps),withRouter)(MFAScanForm);



